'use client'

import { useEffect } from 'react'
import { useSafeRollbar } from '@/hooks/useSafeRollbar'
import { Button } from '@/components/ui/button'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const rollbar = useSafeRollbar()

  useEffect(() => {
    rollbar.error(error)
  }, [error, rollbar])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-4">
            <svg
              className="mx-auto h-12 w-12 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Oops! Something went wrong
          </h2>
          <p className="text-gray-600 mb-6">
            We apologize for the inconvenience. An error has been logged and our team will look into it.
          </p>
          <div className="space-y-3">
            <Button onClick={reset} className="w-full" size="lg">
              Try again
            </Button>
            <Button
              onClick={() => { window.location.href = '/' }}
              variant="outline"
              className="w-full"
              size="lg"
            >
              Go to homepage
            </Button>
          </div>
          {error.digest && (
            <p className="mt-4 text-xs text-gray-400">Error ID: {error.digest}</p>
          )}
        </div>
      </div>
    </div>
  )
}
